<template>
    <div>
        <dx-grid
            url="vMFormLogs"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :expandedOptions="{
                enabled: true,
                template: 'kollel-log-details',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "VM Form Logs",

        actions: [],

        columns: [
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day")
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {},
    beforeDestroy() {},
    methods: {},
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
